module.exports = __webpack_public_path__ + "assets/img/root_components.93fcc0a4.jpg";